module.exports = __webpack_public_path__ + "img/cadou_noiembrie_2023_login.ad098b85.png";